/**
 * Genel amaçlı tanım kaydı.
 * Yeni item/maden/balık/NPC eklemek = ilgili veri dosyasına bir satır eklemek.
 * Sistem kodu değişmez.
 */
export interface Identified {
  readonly id: string;
}

export class Registry<T extends Identified> {
  private map = new Map<string, T>();

  constructor(readonly label: string) {}

  register(...defs: T[]): this {
    for (const def of defs) {
      if (!def || typeof def.id !== 'string' || def.id.length === 0) {
        console.error(`[${this.label}] geçersiz tanım atlandı:`, def);
        continue;
      }
      if (this.map.has(def.id)) {
        console.warn(`[${this.label}] "${def.id}" zaten kayıtlı, üzerine yazılıyor.`);
      }
      this.map.set(def.id, Object.freeze(def));
    }
    return this;
  }

  /** Tanım yoksa null döner; çağıran taraf güvenli fallback uygular. */
  get(id: string | null | undefined): T | null {
    if (!id) return null;
    return this.map.get(id) ?? null;
  }

  /** Tanım şart olan yerlerde: yoksa anlaşılır hata. */
  require(id: string): T {
    const def = this.map.get(id);
    if (!def) throw new Error(`[${this.label}] bilinmeyen id: "${id}"`);
    return def;
  }

  has(id: string): boolean {
    return this.map.has(id);
  }

  all(): T[] {
    return [...this.map.values()];
  }

  filter(pred: (def: T) => boolean): T[] {
    return this.all().filter(pred);
  }

  get size(): number {
    return this.map.size;
  }
}
